import React from 'react';
import { MessageSquare, Zap, ThumbsUp } from 'lucide-react';
import { SecondaryModuleProps } from '../../types/secondaryModule';
import { SecondaryModuleContainer } from './SecondaryModuleContainer';
export function AITutorModule({
  moduleId,
  isOpen,
  onClose
}: SecondaryModuleProps) {
  const data = {
    serviceStatus: {
      coverageRate: 94,
      interactionActivity: 87,
      problemSolvingRate: 92,
      satisfactionRate: 89
    },
    effectAnalysis: {
      learningBehavior: [{
        behavior: '主动提问',
        frequency: 1240
      }, {
        behavior: '知识点查询',
        frequency: 3580
      }, {
        behavior: '作业辅导',
        frequency: 2150
      }],
      knowledgeAcquisitionEfficiency: 85
    },
    aiInsights: [{
      type: 'finding' as const,
      content: '本周AI伴学服务覆盖率达94%，学生使用积极性高'
    }, {
      type: 'finding' as const,
      content: '问题解决率达92%，学生满意度为89%'
    }, {
      type: 'suggestion' as const,
      content: '建议优化AI回答的准确性，特别是数学应用题部分'
    }, {
      type: 'suggestion' as const,
      content: '建议增加AI伴学的个性化推荐功能，提升学习效率'
    }, {
      type: 'prediction' as const,
      content: '预计下月服务覆盖率将突破95%，满意度有望达到90%以上'
    }]
  };
  return <SecondaryModuleContainer moduleId={moduleId} isOpen={isOpen} onClose={onClose} data-id="element-99">
      <div className="grid grid-cols-3 gap-6" data-id="element-100">
        <div className="col-span-2 space-y-6" data-id="element-101">
          {/* Service Status */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-102">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-103">
              <div className="w-1 h-5 bg-[#A78BFA] rounded-full" data-id="element-104"></div>
              伴学服务态势
            </h3>
            <div className="grid grid-cols-4 gap-4" data-id="element-105">
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-106">
                <div className="text-3xl font-bold text-[#A78BFA] mb-1" data-id="element-107">
                  {data.serviceStatus.coverageRate}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-108">服务覆盖率</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-109">
                <div className="text-3xl font-bold text-blue-400 mb-1" data-id="element-110">
                  {data.serviceStatus.interactionActivity}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-111">互动活跃度</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-112">
                <div className="text-3xl font-bold text-green-400 mb-1" data-id="element-113">
                  {data.serviceStatus.problemSolvingRate}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-114">问题解决率</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-115">
                <div className="text-3xl font-bold text-orange-400 mb-1" data-id="element-116">
                  {data.serviceStatus.satisfactionRate}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-117">学生满意度</div>
              </div>
            </div>
          </div>

          {/* Learning Behavior */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-118">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-119">
              <MessageSquare className="w-5 h-5 text-[#A78BFA]" data-id="element-120" />
              学习行为分析
            </h3>
            <div className="space-y-3" data-id="element-121">
              {data.effectAnalysis.learningBehavior.map((behavior, index) => <div key={index} className="flex items-center justify-between p-4 bg-white/5 rounded-lg" data-id="element-122">
                  <span className="text-white" data-id="element-123">{behavior.behavior}</span>
                  <div className="flex items-center gap-3" data-id="element-124">
                    <div className="w-48 h-3 bg-white/10 rounded-full overflow-hidden" data-id="element-125">
                      <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                    width: `${behavior.frequency / 3580 * 100}%`
                  }} data-id="element-126"></div>
                    </div>
                    <span className="text-[#A78BFA] font-bold w-20 text-right" data-id="element-127">
                      {behavior.frequency}次
                    </span>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Knowledge Acquisition Efficiency */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-128">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-129">
              <Zap className="w-5 h-5 text-[#A78BFA]" data-id="element-130" />
              知识获取效率
            </h3>
            <div className="flex items-center justify-center p-8" data-id="element-131">
              <div className="relative w-48 h-48" data-id="element-132">
                <svg className="w-full h-full transform -rotate-90" data-id="element-133">
                  <circle cx="96" cy="96" r="88" stroke="rgba(255,255,255,0.1)" strokeWidth="16" fill="none" data-id="element-134" />
                  <circle cx="96" cy="96" r="88" stroke="#A78BFA" strokeWidth="16" fill="none" strokeDasharray={`${data.effectAnalysis.knowledgeAcquisitionEfficiency / 100 * 553} 553`} strokeLinecap="round" data-id="element-135" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-136">
                  <div className="text-5xl font-bold text-[#A78BFA]" data-id="element-137">
                    {data.effectAnalysis.knowledgeAcquisitionEfficiency}%
                  </div>
                  <div className="text-sm text-gray-400 mt-2" data-id="element-138">效率指数</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: AI Insights */}
        <div className="space-y-6" data-id="element-139">
          <div className="glass-panel p-6 rounded-xl border border-[#A78BFA]/30 bg-gradient-to-br from-[#A78BFA]/10 to-transparent" data-id="element-140">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-141">
              <div className="w-8 h-8 rounded-full bg-[#A78BFA]/20 flex items-center justify-center" data-id="element-142">
                <ThumbsUp className="w-5 h-5 text-[#A78BFA]" data-id="element-143" />
              </div>
              易教智能体洞察
            </h3>
            <p className="text-sm text-gray-400 mb-6" data-id="element-144">
              基于伴学数据分析，易教智能体为您生成以下洞察：
            </p>

            <div className="space-y-4" data-id="element-145">
              <div data-id="element-146">
                <div className="text-sm font-bold text-[#A78BFA] mb-2" data-id="element-147">
                  💡 关键发现
                </div>
                <div className="space-y-2" data-id="element-148">
                  {data.aiInsights.filter(insight => insight.type === 'finding').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-[#A78BFA]/30 py-1" data-id="element-149">
                        {insight.content}
                      </div>)}
                </div>
              </div>

              <div data-id="element-150">
                <div className="text-sm font-bold text-green-400 mb-2" data-id="element-151">
                  🎯 建议措施
                </div>
                <div className="space-y-2" data-id="element-152">
                  {data.aiInsights.filter(insight => insight.type === 'suggestion').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-green-400/30 py-1" data-id="element-153">
                        {insight.content}
                      </div>)}
                </div>
              </div>

              <div data-id="element-154">
                <div className="text-sm font-bold text-orange-400 mb-2" data-id="element-155">
                  📊 预测趋势
                </div>
                <div className="space-y-2" data-id="element-156">
                  {data.aiInsights.filter(insight => insight.type === 'prediction').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-orange-400/30 py-1" data-id="element-157">
                        {insight.content}
                      </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SecondaryModuleContainer>;
}